import { RootState } from '../../model/model'

export const selectStoreId = (state: RootState) => state.settings.selectedStoreId

export const selectRoomId = (state: RootState) => state.settings.selectedRoomId

export const selectAppLang = (state: RootState) => state.settings.language
